import { Component } from '@angular/core';

@Component({
  selector: 'profile-wrapper',
  templateUrl: './profile-wrapper.component.html',
  styleUrl: './profile-wrapper.component.scss'
})
export class ProfileWrapperComponent {}
